import { Box, IconButton, Text, Tooltip } from "@chakra-ui/react";
import { Coordinate } from "~/generated/graphql.types";
import { useContext, useState } from "react";
import Iframe from "react-iframe";
import Draggable from "react-draggable";
import { CloseIcon } from "@chakra-ui/icons";
import { AiOutlineCompress, AiOutlineExpand } from "react-icons/ai";
import { EditModeContext } from "../..";

export const DraggableStreetViewViewer = ({
  clickedCoordinate,
}: {
  clickedCoordinate: Coordinate | undefined;
}) => {
  const { switchStreetViewViewer } = useContext(EditModeContext);

  const [streetViewSize, setStreetViewSize] = useState<"small" | "large">(
    "large"
  );

  const boxWidth = streetViewSize === "large" ? 640 : 480;
  const boxHeight = streetViewSize === "large" ? 360 : 270;
  const paddingSize = 18;

  return (
    <Draggable>
      <Box
        w={`${boxWidth}px`}
        h={`${boxHeight}px`}
        position="absolute"
        zIndex={400}
      >
        <Tooltip label="">
          <IconButton
            size="lg"
            position="absolute"
            top={`${paddingSize}px`}
            right={`${paddingSize}px`}
            bgColor={"#091022"}
            color="white"
            aria-label="expand player"
            variant="ghost"
            icon={<CloseIcon />}
            onClick={() => switchStreetViewViewer(false)}
            zIndex={1000}
          />
        </Tooltip>
        {streetViewSize === "large" ? (
          <Tooltip label="プレイヤーを小さくする">
            <IconButton
              size="lg"
              position="absolute"
              top={`${paddingSize}px`}
              left={`${paddingSize}px`}
              bgColor={"#091022"}
              color="white"
              aria-label="expand player"
              variant="ghost"
              icon={<AiOutlineCompress />}
              onClick={() => setStreetViewSize("small")}
            />
          </Tooltip>
        ) : (
          <Tooltip label="プレイヤーを大きくする">
            <IconButton
              size="lg"
              position="absolute"
              top={`${paddingSize}px`}
              left={`${paddingSize}px`}
              bgColor={"#091022"}
              color="white"
              variant="ghost"
              aria-label="shrink player"
              icon={<AiOutlineExpand />}
              onClick={() => setStreetViewSize("large")}
            />
          </Tooltip>
        )}

        <Box p={`${paddingSize}px`} bgColor={"#091022"} alignItems="center">
          {clickedCoordinate ? (
            <Iframe
              id="streetView"
              url={`https://www.google.com/maps/embed/v1/streetview?key=AIzaSyASX5AB4WGZpcY-asEubq0RSqx8xXa0Kjs&location=${clickedCoordinate.lat},${clickedCoordinate.lon}&heading=0&pitch=10&fov=70`}
              width={`${boxWidth - paddingSize * 2}px`}
              height={`${boxHeight - paddingSize * 2}px`}
            ></Iframe>
          ) : (
            <Text
              width={`${boxWidth - paddingSize * 2}px`}
              height={`${boxHeight - paddingSize * 2}px`}
              align={"center"}
              justify-content={"center"}
              alignItems={"center"}
              color={"white"}
            >
              streetViewを見たい地点を選択してください。
            </Text>
          )}
        </Box>
      </Box>
    </Draggable>
  );
};
